import React, { useEffect, useState } from "react";
import AddAddress from "../account/addAddress";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const Checkout = ({addressReceiver}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [editAddress, setEditAddress] = useState(null); // To store the address being edited
  const [loading, setLoading] = useState(true); // Loading state
  const token = localStorage.getItem("STITCHD_ID");

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component is rendered
    const fetchAddresses = async () => {
      try {
        if (token) {
          const decoded = jwtDecode(token);
          const userId = decoded._id;

          const response = await axios.get(
            `${process.env.REACT_APP_URL}/address/user/${userId}`
          );
          if (response.data.success) {
            setAddresses(response.data.data);
            if (response.data.data.length === 0) {
              setIsModalOpen(true);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      } finally {
        setLoading(false); // Set loading state to false after fetching
      }
    };

    fetchAddresses();
  }, [token, isModalOpen]);

  const openModal = () => {
    setIsModalOpen(true);
    setEditAddress(null); // Clear selected address when opening modal
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleAddressChange = (address) => {
    setSelectedAddress(address);
  };

  const handleDelete = async (addressId) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/address/delete/${addressId}`
      );
      if (response.data.success) {
        // Filter out the deleted address from the addresses state
        setAddresses(addresses.filter((address) => address._id !== addressId));
      }
    } catch (error) {
      console.error("Error deleting address:", error);
    }
  };

  const handleEdit = (address) => {
    setEditAddress(address);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (selectedAddress) {
      addressReceiver(selectedAddress)
    }
  }, [selectedAddress]);

  return (
    <div className="">
      <div className="fixed top-0 left-0 w-full bg-white shadow-lg p-4 z-10 md:hidden">
        <div className="flex justify-between h-auto w-auto">
          <p className="font-semibold">Delivery Address</p>
          <p className="text-gray-400 text-sm">(step 1/2)</p>
        </div>
      </div>
      <div className="mx-4 ">
        <div className="flex justify-center items-center border-2 p-3 border-red-500">
          <button
            className="text-red-500 text-sm font-semibold"
            onClick={openModal}
          >
            <span className="bg-red-500 text-white p-1 px-2 rounded-full mr-2">
              +
            </span>
            ADD NEW ADDRESS
          </button>
        </div>
        {loading ? (
          <div>
            {Array(3).fill().map((_, index) => (
              <div key={index} className="p-2 rounded-lg shadow-md font-twentieth-century w-full mt-8">
                <Skeleton height={40} />
                <div className="mt-4">
                  <Skeleton height={20} count={3} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <>
            {addresses.length === 0 && <div className="md:text-3xl mt-20 text-center">No saved address, add new address to continue</div>}
            {addresses.map((address, index) => (
              <div
                key={index}
                className={`p-2 rounded-lg shadow-md font-twentieth-century w-full mt-8 ${
                  selectedAddress && selectedAddress._id === address._id
                    ? "bg-red-100"
                    : "bg-white"
                }`}
              >
                <label className="custom-radio flex cursor-pointer w-full">
                  <input
                    type="radio"
                    name="address"
                    value={JSON.stringify(address)}
                    checked={selectedAddress && selectedAddress._id === address._id}
                    onChange={() => handleAddressChange(address)}
                    className="hidden"
                  />
                  <span className="radio-btn mr-2 mt-1.5"></span>
                  <div className="w-full">
                    <div className="mb-4 flex justify-between items-center">
                      <p className="text-gray-700 font-semibold md:w-20">
                        {address.name}
                      </p>
                      <div className="flex space-x-2 md:ml-96">
                        <button
                          className="text-gray-400 px-3 py-1 hover:text-gray-600"
                          onClick={() => handleEdit(address)}
                        >
                          Edit
                        </button>
                        <span className="text-gray-400 mt-1">|</span>
                        <button
                          className="text-red-400 px-3 py-1 hover:text-red-600"
                          onClick={() => handleDelete(address._id)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-gray-700 text-lg md:w-80 w-full">
                        {address.address} , {address.landmark}
                      </p>
                      <p className="text-gray-700 text-lg md:w-80 w-full">
                        {address.city} - {address.postalCode}
                      </p>
                    </div>
                    <div className="mb-4 flex font-semibold">
                      <p className="text-lg">Mobile:</p>
                      <p className="text-gray-700 ml-2 mt-0.5">{address.phone}</p>
                    </div>
                  </div>
                </label>
              </div>
            ))}
          </>
        )}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
          <div className="w-auto p-2 border bg-gray-200 rounded-md ">
            <div className="p-6">
              <div className="flex justify-end mt-10">
                <button
                  onClick={closeModal}
                  className="text-red-500 hover:text-red-600 text-lg font-bold"
                >
                  X
                </button>
              </div>
              <AddAddress
                addressToEdit={editAddress} // Pass the selected address to AddAddress for editing
                closeModal={closeModal}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
